<div class="eventq-toast-container" [class.eventq-toast-container--top-right]="position() === 'top-right'">
  @for (toast of toasts(); track toast.id) {
    <article
      class="eventq-toast"
      [class.eventq-toast--exiting]="toast.exiting"
      [class.eventq-toast--tone-error]="toast.tone === 'error'"
      [class.eventq-toast--tone-success]="toast.tone === 'success'"
      [class.eventq-toast--site-armed]="toast.tone == null && toast.variantId === 'site-armed'"
      [class.eventq-toast--download-resolved]="toast.tone == null && toast.variantId === 'download-resolved'"
      [class.eventq-toast--site-disarmed]="toast.tone == null && toast.variantId === 'site-disarmed'"
      [class.eventq-toast--alarm-clip-failed]="toast.tone == null && toast.variantId === 'alarm-clip-attach-failed'"
      [class.eventq-toast--ai-feedback-failed]="toast.tone == null && toast.variantId === 'ai-feedback-failed'"
      [class.eventq-toast--download-failed]="toast.tone == null && toast.variantId === 'download-failed'"
      role="status"
      [attr.aria-label]="toast.title"
      [style.--eventq-toast-duration]="toast.durationMs + 'ms'"
    >
      <span class="eventq-toast__progress" aria-hidden="true"></span>
      <span class="eventq-toast__icon" aria-hidden="true">
        <img [src]="toast.iconSrc" alt="" />
      </span>
      <div class="eventq-toast__content">
        <p class="eventq-toast__title">{{ toast.title }}</p>
        @if (toast.subtitle) {
          <p class="eventq-toast__subtitle">{{ toast.subtitle }}</p>
        }
      </div>
    </article>
  }
</div>
